export enum PPickerPositionEnum {
  TOP_MIDDLE = 'top middle',
  TOP_START = 'top start',
  TOP_END = 'top end',
  CENTER_MIDDLE = 'center middle',
  CENTER_START = 'center start',
  CENTER_END = 'center end',
  BOTTOM_MIDDLE = 'bottom middle',
  BOTTOM_START = 'bottom start',
  BOTTOM_END = 'bottom end',
}

export type PPickerPosition =
  | PPickerPositionEnum.TOP_MIDDLE
  | PPickerPositionEnum.TOP_START
  | PPickerPositionEnum.TOP_END
  | PPickerPositionEnum.CENTER_MIDDLE
  | PPickerPositionEnum.CENTER_START
  | PPickerPositionEnum.CENTER_END
  | PPickerPositionEnum.BOTTOM_MIDDLE
  | PPickerPositionEnum.BOTTOM_START
  | PPickerPositionEnum.BOTTOM_END
